import React from 'react'

import { H2, Span } from '@driftt/tide-core'

import googleLogo from 'images/google.svg'

const GoogleOauth = ({ onConnectClick }) => {
  return (
    <div className="setup-meetings-calendar" onClick={onConnectClick}>
      <img alt="" className="logo calendar-logo" src={googleLogo} />
      <H2 className="setup-meetings-calendar--title">Google Calendar</H2>
      <Span>Gmail, G Suite</Span>
    </div>
  )
}

export default GoogleOauth
